/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSystemSettingValueModel } from '../../models/client-system-setting-value-model';

export interface SaveClientSystemSetting$Params {
  clientID: number;
      body?: ClientSystemSettingValueModel
}

export function SaveClientSystemSetting(http: HttpClient, rootUrl: string, params: SaveClientSystemSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, SaveClientSystemSetting.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

SaveClientSystemSetting.PATH = '/api/Clients/SaveClientSystemSetting/{clientID}';
